import { X } from "lucide-react";
import { PRIMARY_SIDEBAR_WIDTH_PX, SECONDARY_SIDEBAR_WIDTH_PX } from "./layoutConstants";

export interface SecondarySidebarProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  /** Zone sous l’en-tête (ex. panneau Paramètres plein gradient sans padding). */
  contentClassName?: string;
}

export function SecondarySidebar({
  isOpen,
  onClose,
  title,
  subtitle,
  children,
  contentClassName,
}: SecondarySidebarProps) {
  return (
    <aside
      className={[
        "fixed bottom-0 top-0 z-[48] flex flex-col border-r border-[#e4e8ef] bg-white",
        "transition-[transform,opacity] duration-300 ease-in-out",
        isOpen ? "translate-x-0 opacity-100" : "-translate-x-full opacity-0 pointer-events-none",
      ].join(" ")}
      style={{
        left: PRIMARY_SIDEBAR_WIDTH_PX,
        width: SECONDARY_SIDEBAR_WIDTH_PX,
      }}
      aria-hidden={!isOpen}
    >
      <div className="flex shrink-0 items-center justify-between border-b border-[#e4e8ef] p-5">
        <div className="min-w-0 pr-2">
          <div className="truncate text-[10px] font-semibold uppercase tracking-widest text-slate-400">{title}</div>
          {subtitle ? (
            <div className="mt-1 text-xs font-medium text-slate-600">{subtitle}</div>
          ) : null}
        </div>
        <button
          type="button"
          onClick={onClose}
          className="shrink-0 rounded-md p-1.5 text-slate-400 transition-colors duration-150 hover:bg-slate-100 hover:text-slate-800"
          aria-label="Fermer le menu"
        >
          <X className="h-5 w-5" strokeWidth={2} />
        </button>
      </div>
      <div className={contentClassName ?? "min-h-0 flex-1 overflow-y-auto p-4"}>{children}</div>
    </aside>
  );
}
